import { Outlet, createFileRoute, useRouterState } from '@tanstack/react-router';
import { UnifiedFormDetailPage } from '@/components/forms-engine/UnifiedFormsLibrary';

export const Route = createFileRoute('/_dashboard/dashboard/settings/appointment-forms/$id')({
  component: DetailAppointmentFormPage,
});

function DetailAppointmentFormPage() {
  const { id } = Route.useParams();
  const isEditRoute = useRouterState({
    select: (state) => state.location.pathname.endsWith('/edit'),
  });

  if (isEditRoute) {
    return <Outlet />;
  }

  return <UnifiedFormDetailPage id={id} />;
}
